module.exports = __webpack_public_path__ + "img/1702967-37-0.a42222c1.png";